import { render, staticRenderFns } from "./retrievePassword.vue?vue&type=template&id=951eeefa"
import script from "./retrievePassword.vue?vue&type=script&lang=js"
export * from "./retrievePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports